import Slider from 'rc-slider';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const PriceFilter = ({ packageResult, handleFilterChange, filters }) => {
    const [priceRange, setPriceRange] = useState([0, 0]);
    const [currency, setCurrency] = useState(" ");
    const [range, setRange] = useState([0, 0]);

    const lang = useSelector((state) => state.culture.language);

    useEffect(() => {
        if (packageResult && packageResult.length > 0) {
            const prices = packageResult.map((pkg) =>
                parseFloat(pkg.FareDetails?.Total || 0)
            );
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);
            setPriceRange([minPrice, maxPrice]);

            const packageCurrency = packageResult[0]?.FareDetails?.Currency || " ";
            setCurrency(packageCurrency);
        }
    }, [packageResult]);


    useEffect(() => {
        if (filters.priceRange && filters.priceRange.length === 2) {
            setRange(filters.priceRange);
        } else {
            setRange([priceRange[0], priceRange[1]]);
        }
    }, [priceRange]);

    const handleSliderChange = (newRange) => {
        setRange(newRange);
    };

    const handleSliderAfterChange = (newRange) => {
        handleFilterChange("priceRange", newRange);
    };


    const handleClear = () => {
        handleFilterChange("priceRange", priceRange)
        setRange(priceRange)
    }


    return (
        <div className="Filterbox">
            <div className="Filterhead d-flex justify-content-between">
                <div className="FilterTitle">{lang.price}</div>
                <div>
                    {" "}
                    <span className="filter_clear">

                        <a href={undefined} onClick={handleClear}>{lang.clear}</a>
                    </span>{" "}
                </div>
            </div>
            <div className="FilterContent">
                <div className="priceFilterVlaue d-flex justify-content-between">
                    <p className="slide_val">
                        {currency}&nbsp;
                        <span> {range[0].toFixed(3)}</span>
                    </p>
                    <p className="slide_val">
                        {currency}&nbsp;
                        <span> {range[1].toFixed(3)}</span>
                    </p>
                </div>
                <Slider
                    className="range_ui_block"
                    range
                    min={priceRange[0]}
                    max={priceRange[1]}
                    value={range}
                    onChange={handleSliderChange}
                    onAfterChange={handleSliderAfterChange}
                    allowCross={false}
                    handleStyle={{
                        borderColor: "grey",
                        backgroundColor: "grey",
                    }}
                />
            </div>
        </div>
    )
}

export default PriceFilter